import React from "react";
import CrossIcon from "../images/CrossIcon.svg";
import "./PaymentMode.scss";
import { ButtonCustom } from "../UI/ButtonCustom/ButtonCustom";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { formatDateTime } from "../common/commonFunctions";

function TransactionFailed() {
  const location = useLocation();
  const payDetails = location.state;
  const userDetails = useSelector((state) => state?.user?.user); // Adjust according to your actual state

  const handleDoneClick = () => {
    const redirectUrl = userDetails?.redirect_url || "https://google.com";
    if (redirectUrl) {
      localStorage.clear();
      window.location.replace(redirectUrl); // This will navigate to the new domain
    }
  };
  return (
    <div className="container">
      <div className="details commonBG">
        <img src={CrossIcon} alt="CrossIcon" />
        <h3>Transaction Failed! Please try again later.</h3>
        <div className="details_inner">
          {payDetails?.amount && payDetails?.amount_in_usd ? (
            <div>
              <h5>Amount</h5>
              <p>
                {payDetails?.amount} {userDetails?.crypto}= $
                {payDetails?.amount_in_usd}
              </p>
            </div>
          ) : null}
          {payDetails?.to_address ? (
            <div>
              <h5>Address</h5>
              <p>{payDetails?.to_address}</p>
            </div>
          ) : null}
          {payDetails?.to_address ? (
            <div>
              <h5>Payment Mode</h5>
              <p>Triskel Pay</p>
            </div>
          ) : null}
          {payDetails?.created_at ? (
            <div>
              <h5>Purchased On</h5>
              <p>{formatDateTime(payDetails?.created_at)}</p>
            </div>
          ) : null}
        </div>
        <ButtonCustom basicBtn label="Done" onClick={handleDoneClick} />
      </div>
    </div>
  );
}

export default TransactionFailed;
